require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-tech-tip-clean-up-your-code-with-lighter-view-controllers-in-swift.json") })
        }
      }, "path---blog-tech-tip-clean-up-your-code-with-lighter-view-controllers-in-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-tech-tip-clean-up-your-code-with-lighter-view-controllers-in-swift!./.cache/json/blog-tech-tip-clean-up-your-code-with-lighter-view-controllers-in-swift.json
// module id = 1080
// module chunks = 231608221292675